// extracted by mini-css-extract-plugin
export default {"chevron":"FlatTreeXMLChevron_chevron__AJ0QA","collapsed":"FlatTreeXMLChevron_collapsed__uSi8x"};